// extracted by mini-css-extract-plugin
module.exports = {"sidetab":"tabs_sidetab__ZxjQh","active":"tabs_active__I_xki","list-not-styled":"tabs_list-not-styled__wlofc"};